import { useState } from "react";
import { Lock, ShieldAlert } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { ConfirmDialog } from "./ConfirmDialog";

const LABEL = { present: "Present Batch participants", guides: "Guides" };

export const stepsAudience = (c) => c?.home_audience || ["guides", "present"];

export const StepsViewToggle = ({ cls, who }) => {
  const [ask, setAsk] = useState(false);
  const c = cls.classroom;
  if (!c) return null;
  const aud = stepsAudience(c);
  const on = aud.includes(who);
  const stopped = c.master_control === "stop";
  const save = (v) => cls.saveField("home_audience", v ? [...aud.filter((x) => x !== who), who] : aud.filter((x) => x !== who));
  return (
    <>
      <label data-testid={`steps-view-toggle-${who}`} className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs transition-colors ${stopped ? "border-red-200 bg-red-50/60 text-muted-foreground opacity-70" : on ? "border-amber-400 bg-amber-50 text-amber-900" : "border-border bg-white text-muted-foreground"}`} title={stopped ? "Master Control (13 Classroom) is STOP — Register Steps are locked OFF" : `Register Steps (13b) for ${LABEL[who]}: when ON, ${LABEL[who]} can log in at Step 2 and open the classroom videos. When OFF, they cannot log in.`}>
        {stopped ? <Lock size={14} className="text-red-500" /> : on && <ShieldAlert size={14} className="text-amber-600" />}
        <span className="font-medium">Register Steps view</span><span data-testid={`steps-view-state-${who}`} className="font-semibold">{stopped ? "OFF (Master STOP)" : on ? "ON" : "OFF"}</span>
        <Switch data-testid={`steps-view-switch-${who}`} disabled={stopped} checked={on && !stopped} onCheckedChange={(v) => (v ? setAsk(true) : save(false))} />
      </label>
      <ConfirmDialog open={ask} testId={`steps-view-confirm-${who}`} title="Switch ON Register Steps?" confirmLabel="Yes, give access" cancelLabel="No, keep OFF"
        lines={[`Are you sure? Do you want to give ${LABEL[who]} access to the Register Steps?`, "They will be able to log in at Step 2 and open the classroom videos at Step 3 (when Start Present Batch is ON)."]}
        onCancel={() => setAsk(false)} onConfirm={() => { setAsk(false); save(true); }} />
    </>
  );
};

export const StepsOnAlert = ({ cls, who = "present" }) => {
  const c = cls.classroom;
  if (!c || !stepsAudience(c).includes(who)) return null;
  return (
    <div data-testid={`steps-on-alert-${who}`} role="alert" className="mb-3 flex items-start gap-3 rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 text-amber-900 transition-colors group-hover/sec:bg-amber-100 group-hover/sec:border-amber-500">
      <ShieldAlert size={20} className="mt-0.5 shrink-0 text-amber-600 group-hover/sec:animate-pulse" />
      <div className="text-sm">
        <p className="font-semibold">Register Steps are ON for {LABEL[who]}</p>
        <p className="text-xs mt-0.5 text-amber-800">{LABEL[who]} can log in at Step 2 and open the classroom videos. Switch OFF the toggle at the top right if video access should not be given yet.</p>
      </div>
    </div>
  );
};
